export default __webpack_public_path__ + "static/media/ic_morocco.11279be9.svg";